/**
 * AssemblyAI client-side configuration.
 *
 * Tokens are now issued by the dedicated Cloudflare Worker
 * (`assemblyai-token-worker/`). The browser never touches raw API keys—
 * it only consumes temporary tokens by calling the worker URL that lives
 * in `VITE_ASSEMBLYAI_TOKEN_URL`.
 */

export const ASSEMBLYAI_CONFIG = {
    sampleRate: 16000,
    formatTurns: true,
    languageCode: 'en_US',
    enableLanguageDetection: true
} as const;

export const ASSEMBLYAI_TOKEN_REQUEST_DEFAULTS = {
    expiresInSeconds: 300,
    maxSessionDurationSeconds: 3600
} as const;

